import { render } from "./LiveRecoveryBanner.vue?vue&type=template&id=90d6e72e&scoped=true"
import script from "./LiveRecoveryBanner.vue?vue&type=script&lang=js"
export * from "./LiveRecoveryBanner.vue?vue&type=script&lang=js"

import "./LiveRecoveryBanner.vue?vue&type=style&index=0&id=90d6e72e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d6e72e"]])

export default __exports__